export default __webpack_public_path__ + "static/media/fe_dial_hand.0a2bc10a.svg";